"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _VideoSummaryCard = _interopRequireDefault(require("../../VideoSummaryCard"));

require("../styles/_video-list-summary.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getCountFromStats(card, statsKey, stats) {
  if (!Array.isArray(card.status)) {
    return (0, _lodash.default)(stats, "".concat(statsKey, ".status.").concat(card.status), 0);
  }

  return card.status.reduce(function (count, status) {
    return count + (0, _lodash.default)(stats, "".concat(statsKey, ".status.").concat(status), 0);
  }, 0);
}

function Summary(_ref) {
  var small = _ref.small,
      stats = _ref.stats,
      selectedFilters = _ref.selectedFilters,
      title = _ref.title,
      subtitle = _ref.subtitle,
      summaryCards = _ref.summaryCards;
  var statsKey = selectedFilters.USER && selectedFilters.USER.includes('ALL') ? 'global' : 'user';
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "column"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-list-summary', {
        'video-list-summary--medium': small
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-summary__header"
    }, /*#__PURE__*/_react.default.createElement("p", null, title), subtitle ? /*#__PURE__*/_react.default.createElement("p", null, subtitle) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-list-summary__cards"
    }, summaryCards.map(function (card) {
      return (0, _react.isValidElement)(card) ? _react.default.cloneElement(card, {
        small: small
      }) : /*#__PURE__*/_react.default.createElement(_VideoSummaryCard.default, {
        key: Array.isArray(card.status) ? card.status[0] : card.status,
        label: card.label,
        count: getCountFromStats(card, statsKey, stats),
        status: card.overrideStatus || (Array.isArray(card.status) ? card.status[0] : card.status),
        small: small
      });
    }))))
  );
}

var _default = (0, _react.memo)(Summary);

exports.default = _default;